var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.activeClass ? 'class-a' : 'class-b',on:{"click":_vm.fn}},[_vm._v(_vm._s(_vm.btn_text))])}
var staticRenderFns = []

export { render, staticRenderFns }